<template>
  <form @submit.prevent="onSubmit">
    <div class="form-row align-items-center">
      <div class="col-auto">
        <label class="sr-only" for="name">Название</label>
        <input
            class="form-control mb-2"
            id="name"
            v-model="local.name"
            type="text"
            placeholder="Название"
            required
        >
      </div>
      <div class="col-auto" v-if="categories">
        <label class="sr-only" for="category">Категория</label>
        <select
            id="category"
            class="form-control mb-2 form-select"
            v-model="local.categoryId"
        >
          <option
              v-for="cat in categories"
              :key="cat.id"
              :value="cat.id"
              :selected="local.categoryId === cat.id"
          >
            {{ cat.name }}
          </option>
        </select>
      </div>
      <div class="col-auto">
        <label class="sr-only">
          <span>Тип</span>
          <select class="form-control mb-2" v-model="local.type">
            <option value="expense">Расход</option>
            <option value="income">Доход</option>
          </select>
        </label>
      </div>
      <div class="col-auto">
        <label class="sr-only" for="amount">Сумма</label>
        <input
            class="form-control"
            v-model.number="local.amount"
            ref="amountRef"
            inputmode="decimal"
            placeholder="100"
            required
        >
      </div>
      <div class="col-auto">
        <label class="sr-only" for="createdAt">Дата</label>
        <input
            id="createdAt"
            class="form-control mb-2"
            type="datetime-local"
            v-model="local.createdAt"
            required
        />
      </div>
      <div class="col-auto">
        <label class="sr-only">
          <span class="">Геопозиция (опционально)</span>
          <div class="mb-4">
            <input
                class="form-control"
                type="hidden"
                placeholder="lat"
                v-model="local.latitude"
            />
            <input
                class="form-control"
                type="hidden"
                placeholder="lng"
                v-model="local.longitude"
            />
            <button type="button" class="btn btn-outline-primary btn-sm" @click="onSelectLocation">
              🗺️ Выбрать на карте
            </button>
          </div>
        </label>
      </div>
      <div class="text-danger g-3 mt-3 d-flex justify-content-center align-items-center" v-if="props.errorMessage">
        <span>{{ props.errorMessage }}</span>
      </div>
      <div class="col-auto g-3 mt-3">
        <button class="btn btn-primary mb-2" type="submit">
          Сохранить
        </button>
      </div>
    </div>
  </form>
</template>

<script setup>
import {onMounted, reactive, ref, watch} from 'vue';
import {toLocalInputValue, nowLocal, normalizeAmountInput} from '@/api/helpers';

const props = defineProps({
  categories: { type: Array, required: false },
  initial: {type: Object, required: false },
  errorMessage: {type: String, required: false },
});

const amountRef = ref(null);
onMounted(async () => {
  normalizeAmountInput(amountRef);
});
const local = reactive({
  id: props.initial?.id ?? '',
  name: props.initial?.name ?? '',
  amount: props.initial.amount != null ? Math.abs(props.initial.amount) : '',
  type:
      props.initial?.amount != null && props.initial?.amount > 0
          ? 'income'
          : 'expense',
  categoryId: props.initial?.categoryId ?? '',
  createdAt: (props.initial?.createdAt ? toLocalInputValue(props.initial?.createdAt) : nowLocal()),
  latitude: props.initial?.latitude ?? null,
  longitude: props.initial?.longitude ?? null,
});
const emit = defineEmits(['submit', 'openMap']);
function onSubmit() {
  let amount = Number(local.amount) || 0;
  if (local.type === 'expense') {
    amount = -Math.abs(amount);
  } else {
    amount = Math.abs(amount);
  }
  emit('submit', {...local, amount});
}

watch(
    () => props.initial,
    (v) => {
      if (!v) return;
      if (v.latitude && v.latitude) {
        local.latitude = v.latitude;
        local.longitude = v.longitude;
        return;
      }
      local.name = v.name ?? '';
      local.amount = v.amount != null ? Math.abs(v.amount) : 0;
      local.createdAt = v.createdAt ?? toLocalInputValue(v.createdAt);
      local.latitude = v.latitude ?? '';
      local.longitude = v.longitude ?? '';
      local.type =
          v.amount != null && v.amount < 0
              ? 'expense'
              : 'income';
    },
    { deep: true }
);

function onSelectLocation() {
  const latitude = local.latitude ? Number(local.latitude) : null;
  const longitude = local.longitude ? Number(local.longitude) : null;
  emit('openMap', { latitude, longitude }, true);
}
</script>
